import { ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";

interface UtilsState {
  loaded_category: boolean;
  loading_category: boolean;
  loading_shipment_forecast_week_plan: boolean;
  production_plan_recalc_loading: boolean;
  transport_chart_cache_loading: boolean;
}

const state: UtilsState = {
  loading_category: false,
  loaded_category: false,
  loading_shipment_forecast_week_plan: false,
  production_plan_recalc_loading: false,
  transport_chart_cache_loading: false
};

export const TRANSPORT_CHART_CACHE_REBUILD = "TRANSPORT_CHART_CACHE_REBUILD";

export const EMPLOYEE_LIST = "EMPLOYEE_LIST";

export const actions: ActionTree<UtilsState, RootState> = {
  recalcCategory({ commit, getters, dispatch, state }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING_CATEGORY");

      vm.$http.get(`/api/v1/update_abc`, {}, {}).then((response: any) => {
        commit("LOADED_SUCCESS_CATEGORY");
        resolve();
      });
    });
  },

  recalcShipmentForecastWeekPlan({ commit }) {
    const vm = (this as any)._vm;
    return new Promise((resolve, reject) => {
      commit("SET_SHIPMENT_FORECAST_WEEK_PLAN_LOADING", true);
      vm.$http
        .get(`/api/v1/update_shipment_forecast_week_plan`, {}, {})
        .then(() => {
          commit("SET_SHIPMENT_FORECAST_WEEK_PLAN_LOADING", false);
          vm.$buefy?.toast?.open?.({
            message: "План прогноза отгрузок обновлён",
            type: "is-success"
          });
          resolve(null);
        })
        .catch((err: any) => {
          commit("SET_SHIPMENT_FORECAST_WEEK_PLAN_LOADING", false);
          vm.$buefy?.toast?.open?.({
            message:
              err?.response?.data?.error ||
              err?.response?.data?.message ||
              "Ошибка обновления плана",
            type: "is-danger"
          });
          reject(err);
        });
    });
  },
  recalculateProductionPlan({ commit }) {
    const vm = (this as any)._vm;
    return new Promise((resolve, reject) => {
      commit("SET_PRODUCTION_PLAN_RECALC_LOADING", true);
      vm.$http
        .post(`/api/v1/production_forecast/recalculate_from_settings`, {}, {})
        .then(() => {
          commit("SET_PRODUCTION_PLAN_RECALC_LOADING", false);
          vm.$buefy?.toast?.open?.({ message: "План обновлён", type: "is-success" });
          resolve(null);
        })
        .catch((err: any) => {
          commit("SET_PRODUCTION_PLAN_RECALC_LOADING", false);
          vm.$buefy?.toast?.open?.({
            message: err?.response?.data?.message || "Ошибка пересчёта",
            type: "is-danger"
          });
          reject(err);
        });
    });
  },

  recalculateTransportChartCache({ commit }, months: number) {
    const vm = (this as any)._vm;
    return new Promise((resolve, reject) => {
      commit("SET_TRANSPORT_CHART_CACHE_LOADING", true);
      vm
        .$db([
          vm
            .$q(TRANSPORT_CHART_CACHE_REBUILD)
            .raw("reports.client_transport_chart_cache_rebuild")
            .action({ months })
        ])
        .then((result: ServerResult) => {
          commit("SET_TRANSPORT_CHART_CACHE_LOADING", false);
          const op = result.getOperation(TRANSPORT_CHART_CACHE_REBUILD);
          if (op && op.hasError()) {
            vm.$buefy?.toast?.open?.({
              message: "Ошибка пересчёта кэша транспорта",
              type: "is-danger"
            });
            reject(new Error("batch error"));
            return;
          }
          vm.$buefy?.toast?.open?.({
            message: `Кэш транспортных расходов пересчитан за ${months} мес.`,
            type: "is-success"
          });
          resolve(null);
        })
        .catch((err: any) => {
          commit("SET_TRANSPORT_CHART_CACHE_LOADING", false);
          vm.$buefy?.toast?.open?.({
            message: err?.message || "Ошибка пересчёта кэша",
            type: "is-danger"
          });
          reject(err);
        });
    });
  }
};

export const mutations: MutationTree<UtilsState> = {
  START_LOADING_CATEGORY: state => {
    state.loaded_category = false;
    state.loading_category = true;
  },
  LOADED_SUCCESS_CATEGORY: state => {
    state.loaded_category = true;
    state.loading_category = false;
  },

  SET_SHIPMENT_FORECAST_WEEK_PLAN_LOADING: (state, value: boolean) => {
    state.loading_shipment_forecast_week_plan = value;
  },

  SET_PRODUCTION_PLAN_RECALC_LOADING: (state, value: boolean) => {
    state.production_plan_recalc_loading = value;
  },

  SET_TRANSPORT_CHART_CACHE_LOADING: (state, value: boolean) => {
    state.transport_chart_cache_loading = value;
  }
};

const getters: GetterTree<UtilsState, RootState> = {};

export const STORE_KEY = "$_utils";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
